import React from 'react';
import { useParams } from "react-router-dom";
import styled from 'styled-components';

import PasswordRecoveryTool from "../users/tools/PasswordRecoveryTool";

export default function PasswordRecoveryApp() {
  const { recoveryKey } = useParams();

  return (
    <Wrapper className={'p-4'}>

      <PasswordRecoveryTool recoveryKey={recoveryKey}/>

    </Wrapper>
  );
}

const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
`;